import React from "react";
import Switch from "react-switch";
import { Color } from "taskpane/models/enums";

export interface ISwitchSetting {
  checked: boolean;
  onChange: (isChecked: boolean) => void;
  "data-testid"?: string;
}

const SwitchSetting: React.FC<ISwitchSetting> = (props: ISwitchSetting): React.JSX.Element => {
  return (
    <Switch
      width={36}
      height={20}
      checkedIcon={false}
      uncheckedIcon={false}
      handleDiameter={12}
      onColor={Color.primary}
      offColor={Color.disabled}
      checked={props.checked}
      onChange={(isChecked) => props.onChange(isChecked)}
      data-testid={props["data-testid"]}
    />
  );
};

export default SwitchSetting;
